import React from 'react';
import { number, string } from 'prop-types';
import { contains } from 'ramda';
import styled from 'styled-components';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';

import { valueFormat } from '../../utils/format';
import { Precision as IPrecision } from '../../models';

class CompareTableRow extends React.Component {
  render() {
    const {
      name,
      timespan,
      total,
      rate,
      population,
      children,
      precision,
      firstIntervalPopulation,
      secondIntervalPopulation,
      firstIntervalMurders,
      secondIntervalMurders,
      firstIntervalRate,
      secondIntervalRate,
      selected,
      onSelect,
      id,
      selectedLocationsIds,
      ...rest
    } = this.props;

    return (
      <TableRow {...rest}>
        <TableCell padding="checkbox">
          <Checkbox
            checked={contains(id, selectedLocationsIds)}
            onClick={event => onSelect(event, id)}
            color="primary"
          />
        </TableCell>
        <TableCell>{name}</TableCell>
        <TableCell>{valueFormat(total)}</TableCell>
        <TableCell>{valueFormat(rate)}</TableCell>
        <TableCell>{valueFormat(firstIntervalMurders)}</TableCell>
        <TableCell>{valueFormat(secondIntervalMurders)}</TableCell>
        <TableCell>{valueFormat(firstIntervalRate)}</TableCell>
        <TableCell>{valueFormat(secondIntervalRate)}</TableCell>
        <TableCell>{valueFormat(firstIntervalPopulation)}</TableCell>
        <TableCell>{valueFormat(secondIntervalPopulation)}</TableCell>
      </TableRow>
    );
  }
}

CompareTableRow.propTypes = {
  name: string.isRequired,
  precision: IPrecision.isRequired,
  timespan: string,
  total: number,
  rate: number,
  population: number,
};

export default styled(CompareTableRow)`
  & > * {
    background-color: ${({ theme }) => theme.colors.white} !important;
  }

  &:hover > * {
    background-color: ${({ theme }) => theme.colors.grey300} !important;
  }
`;



// WEBPACK FOOTER //
// ./src/components/LocationTable/CompareTableRow.jsx